import React from 'react';
import Box from '@mui/material/Box';

import { Autocomplete, TextField, Switch, InputAdornment, Icon } from '@mui/material';
// import { withStyles } from '@material-ui/core/styles';
// import PictureInPictureIcon from '@mui/icons-material/PictureInPicture';
import CloseIcon from '@mui/icons-material/Close';

import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';

import { useMovie } from "../../movie/MovieProvider";
import { useMovieSetter } from "../../movie/MovieProvider";

// fields
import VEComponentSettings from './VEComponentSettings';
import VESource from './VESource';
import VEColorPicker from './VEColorPicker';
import VEComponentPicker from './VEComponentPicker';
import VEVoiceGenerator from './VEVoiceGenerator';

import { ColorPicker } from 'mui-color';

const StyledField = {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#F5F5F5',
      },
      '&:hover fieldset': {
        borderColor: '#C5C5C5',
      },
      '& input[type=number]::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none', 
        margin: 0
      }
    },
    '& .MuiInputBase-root.Mui-disabled': {
      '& > fieldset': {
          borderColor: '#F5F5F5',
      }
    }
};


export default function VEField(props) {

    const movie = useMovie();
    const setMovie = useMovieSetter();

    if (!movie.selected) return (<></>);

    const { index, schema, value } = props;
    let { property } = props;
    const element = movie.selected.pointer;

    // property is the name of the field
    // parent is the path to the field, like settings.headline
    const fullPathToProperty = property;
    const fieldPath = property.split(".");
    property = fieldPath.pop();
    const parent = fieldPath.join(".");

    // console.log("VEField: ", property, parent);

    if (!schema || typeof(schema) !== "object") {
        console.log("No schema for", {
            index,
            schema,
            property,
            value,
            parent
        });
        return (<></>);
    }

    if (property === 'type') return <></>; // bypass the type field
    if (property === 'hidden' && value === true) return <></>; // bypass the hidden fields

    let cssClasses = "pr-3 mt-3 grow relative";

    // Get the min and max values for user tips
    let minMaxText = "";
    if ("minimum" in schema) {
        minMaxText = `min value: ${schema.minimum}`;
    }
    if ("maximum" in schema) {
        if (minMaxText.length) minMaxText += ", ";
        minMaxText += `max value: ${schema.maximum}`;
    }
    if (minMaxText.length) minMaxText = `[${minMaxText}]`;
    
    // Render the field
    return formField();

    //
    // FUNCTIONS
    //

    function fieldTitle() {
        const displayName = (schema && schema.title) ? schema.title : property;
        return (
            <span style={{ fontFamily: 'monospace', fontSize:"10px", color: "#888" }}>{displayName}</span>
        );
    }

    function fieldDescription() {

        return (
            <span className="text-gray-400">
                <span className="italic">{(schema.format) ? schema.format : schema.type}.</span> &nbsp;
                {/* <span dangerouslySetInnerHTML={{ __html: schema.description ?? "" }}></span> */}
            </span>
        );
    }

    

    // This function renders the field based on its type and properties
    function formField() {

        let fieldEnabled = true;
        
        // Get the style
        let containerStyle = {
            width: (schema && schema.width) ? schema.width : "100%",
            minWidth: (schema && schema.minWidth) ? schema.minWidth : undefined
        };
        
        // InputProps
        let inputProps = {style: { fontFamily: 'monospace', fontSize: "12px" }}, inputLabel = null;

        let fieldType = schema.type;

        if (schema) {
            if (schema.title) {
                const paddingTop = (schema.control === "stringMultiline") ? "10px" : "3px";
                const marginLeft = (schema.enum) ? "8px" : "0px";
                switch(schema.titlePosition) {
                    case "prefix": inputProps = { ...inputProps, startAdornment: <InputAdornment position="start" disableTypography={true} sx={{fontSize: "10px", paddingTop: paddingTop, marginLeft: marginLeft }}>{schema.title}</InputAdornment> }; break;
                    case "placeholder": inputLabel = schema.title; break;
                    default: inputProps = { ...inputProps, startAdornment: <InputAdornment position="start" disableTypography={true} sx={{fontSize: "10px", paddingTop: paddingTop, marginLeft: marginLeft }}>{schema.title}</InputAdornment> }; break;
                }
            }
            if (schema.unit) {
                inputProps = { ...inputProps, endAdornment: <InputAdornment position="end" disableTypography={true} sx={{fontSize: "10px", paddingTop: "3px" }}>{schema.unit}</InputAdornment> };
            }
        }

        // Check if the field depends on other field value
        // Based on the dependency, the field is disabled or not
        if (schema && schema.disabled) fieldEnabled = false;
        else if (typeof schema.dependsOn === "object") {
            let valid = false;
            Object.keys(schema.dependsOn).forEach((key) => {
                if (element[key] === schema.dependsOn[key]) valid = true;
                if (schema.dependsOn[key] === "__not_empty__" && element[key] && element[key] !== "") valid = true;
            });
            if (!valid) fieldEnabled = false;
        }

        if (fieldType === "string") {
            return stringFields(inputProps);
        }
        else if (fieldType === "number" || fieldType === "integer") {
            return numberFields();
        }
        else if (fieldType === "boolean") {
            return (
                <Box key={index} className={cssClasses+" pl-2"}>
                    {fieldTitle()}
                    <Switch id={property} checked={(value === true)} onChange={updateBooleanProperty} />
                </Box>
            );
        }
        else if (fieldType === "object") {

            if (schema.control === "component-settings") {
                // return (
                //     <Box key={index} className={cssClasses}>
                //         <VEComponentSettings {...props} property={property} param={param} element={element} />
                //     </Box>
                // );
            }

            return (
                <Box key={index} className={cssClasses}>
                    <details>
                        <summary>
                            <span className="ml-2">{fieldTitle()}</span>
                            <p>{fieldDescription()}</p>
                        </summary>
                        {regularObjectField()}
                    </details>
                </Box>

            );
        }

        // Container box helper
        function containerBox(index, content, classes=null, style=null) {
            if (!classes) classes = cssClasses;
            if (!style) style = containerStyle;

            return (
                <Box key={index} className={classes} style={style}>
                    {content}
                    {
                        (schema.disabled) ? <></> :
                        (schema.optional) ?
                        <Box sx={{background: "white", width: "20px", height: "20px", padding:"2px", right: "0px", top: "-8px", position: "absolute", cursor: "pointer"}}>
                            <HighlightOffOutlinedIcon sx={{ fontSize: "12px", color: "gray" }} onClick={removeField} />
                        </Box>
                        :
                        <Box sx={{background: "white", width: "20px", height: "20px", padding:"2px", right: "0px", top: "-8px", position: "absolute", cursor: "pointer"}}>
                            <RemoveCircleOutlineOutlinedIcon sx={{ fontSize: "12px", color: "lightgray" }} onClick={clearField} />
                        </Box>
                    }
                </Box>
            );
        }

        // Render fields of type "string"
        function stringFields(inputProps) {

            // console.log("stringFields", schema);

            // if the field has an enum property, render a dropdown
            if (schema.enum) {
                return containerBox(
                    index,
                    <Autocomplete 
                        id={property} 
                        onChange={(e, value) => { updateAutocompleteProperty(property, value) }} 
                        // className="flex-grow"
                        sx = {StyledField}
                        value={(value && value.length) ? value : null} 
                        options={schema.enum}
                        // InputProps = {inputProps}
                        renderInput={(params) => 
                            <TextField {...params} 
                                variant="outlined" 
                                size="small"
                                autoComplete="off"
                                InputProps={{
                                    ...params.InputProps,
                                    ...inputProps,
                                }}
                            />
                        } />
                );
            }
            
            // if the field is a color value
            if ((schema.control && schema.control === "color") || property === "color" || property === "background-color") {
                // color picker
                return containerBox(
                    index,
                    <Box className="py-1 pr-2 flex items-center justify-between border border-gray-100 hover:border-gray-300 rounded-md" style={{ paddingLeft: "15px" }}>
                        {fieldTitle()}
                        <VEColorPicker value={value} onChange={updateColorProperty} />
                    </Box>
                );
            }

            if (schema.control) {
                // console.log("Field has a control");
                if (schema.control === "component-picker") {
                    return (
                        <Box key={index} className={cssClasses}>
                            <p>{fieldTitle()}</p>
                            <VEComponentPicker {...props} value={value} element={element} fieldDescription={fieldDescription} updateProperty={replaceComponentProperties} />
                        </Box>
                    );
                }
                else if (schema.control === "voice-generator") {
                    return (
                        <Box key={index} className={cssClasses}>
                            <p>{fieldTitle()}</p>
                            <VEVoiceGenerator {...props} value={value} element={element} fieldDescription={fieldDescription} updateProperty={updatePropertyByEvent} />
                        </Box>
                    );
                }
                else if (schema.control === "stringMultiline") {
                    return stringMultilineFields(inputProps);
                }
            }
            
            // if the field is a source
            if (schema.format === "uri") {
                return containerBox(
                    index,
                    <VESource 
                            element={element} 
                            field={schema} 
                            label = {inputLabel}
                            sx = {StyledField}
                            InputProps = {{ ...inputProps, style: { fontFamily: 'monospace', fontSize:"12px" }}}
                            movieWidth={movie.movieObject.width} 
                            movieHeight={movie.movieObject.height} 
                            updateProperty={updateSourceProperty} />
                );
            }

            // default: regular text field

            return containerBox(
                index, 
                <TextField 
                    id={property} 
                    onChange={updatePropertyByEvent} 
                    value={value} 
                    style={{ width: "100%" }}
                    sx = {StyledField}
                    variant="outlined"
                    size="small"
                    autoComplete="off"
                    disabled={!fieldEnabled}
                    label = {inputLabel}
                    InputProps={{ ...inputProps, style: { fontFamily: 'monospace', fontSize:"12px" }}} />
            );
        }

        function stringMultilineFields(inputProps) {
            return containerBox(
                index, 
                <TextField 
                    id={property} 
                    onChange={updatePropertyByEvent} 
                    value={value} 
                    style={{ width: "100%" }}
                    sx = {StyledField}
                    variant="outlined"
                    size="small"
                    autoComplete="off"
                    disabled={!fieldEnabled}
                    label = {inputLabel}
                    multiline
                    InputProps={{ ...inputProps, style: { marginTop: '10px', fontFamily: 'monospace', fontSize:"12px", alignItems: 'start' }}} />
            );
        }

        function numberFields() {

            return containerBox(
                index,
                <TextField 
                    id={property} 
                    onChange={updatePropertyByEvent}
                    sx={StyledField}
                    style={{ width: "100%" }}
                    type="number" 
                    value={(fieldEnabled) ? value : ""} 
                    variant="outlined"
                    size="small"
                    autoComplete="off"
                    disabled={!fieldEnabled}
                    label = {inputLabel}
                    inputProps={{ style: {textAlign: "right"} }}
                    InputProps={{ ...inputProps, style: { fontFamily: 'monospace', fontSize:"12px" }}} />
            );
        }
    }

    function removeField() {
        updateProperty(undefined);
        console.log("Remove property: ", fullPathToProperty);
        props.onPropertyRemove(fullPathToProperty);
    }

    function clearField() {
        updateProperty("");
    }

    // 
    // UPDATE PROPERTY FUNCTIONS
    // This functions control de property updates
    //

    function updateProperty(newValue) {

        if (newValue === "" || newValue === null) {
            newValue = undefined;
        }
        else {
            if ((schema.type === "number" && schema.format === "integer") || schema.type === "integer") {
                newValue = parseInt(newValue);
            }
            else if (schema.type === "number" || schema.type === "float") {
                newValue = parseFloat(newValue);
            }
        }

        setMovie({
            type: "updateProperties",
            itemId: movie.selected.itemId,
            field: parent,
            properties: {
                [property]: newValue
            }
        });
    }

    function updatePropertyByEvent(event) {
        updateProperty(event.target.value);
    }

    function updateColorProperty(colorObject) {
        const newValue = (colorObject.hex) ? `#${colorObject.hex}` : colorObject;

        setMovie({
            type: "updateProperties",
            itemId: movie.selected.itemId,
            field: parent,
            properties: {
                [property]: newValue
            }
        });
    }

    function updateSourceProperty(sourceResponse) {
        console.log("Update Source", property, sourceResponse);

        if (sourceResponse) {
            let elementChanges = {
                [property]: sourceResponse.url
            };
            if (sourceResponse.scale) {
                //elementChanges["scale"] = sourceResponse.scale;
                elementChanges.width = sourceResponse.scale.width;
                elementChanges.height = sourceResponse.scale.height;
                elementChanges.x = 0;
                elementChanges.y = 0;
            }

            setMovie({
                type: "updateProperties",
                itemId: movie.selected.itemId,
                field: parent,
                properties: elementChanges
            });
        }
    }

    function replaceComponentProperties(elementChanges) {
        // console.log("Replace component properties", elementChanges, movie.selected.itemId, parent);
 
        if (element.type === "text") {
            setMovie({
                type: "updateProperties",
                itemId: movie.selected.itemId,
                properties: {
                    style: elementChanges.style
                }
            });
        }
        else {
            setMovie({
                type: "updateProperties",
                itemId: movie.selected.itemId,
                properties: elementChanges
            });
        }
    }

    function updateBooleanProperty(event) {
        setMovie({
            type: "updateProperties",
            itemId: movie.selected.itemId,
            field: parent,
            properties: {
                [property]: (event.target.checked) ? true : false
            }
        });
    }

    function updateAutocompleteProperty(property, value) {
        let updatedElement;

        if (property === "resolution") {
            const { width, height } = getResolutionSize(value);

            setMovie({
                type: "updateProperties",
                itemId: movie.selected.itemId,
                field: parent,
                properties: {
                    width: width,
                    height: height,
                    resolution: value
                }
            });
        }
        else {
            setMovie({
                type: "updateProperties",
                itemId: movie.selected.itemId,
                field: parent,
                properties: {
                    [property]: value
                }
            });
        }
    }

    function regularObjectField() {
        // A regular object field with defined properties in the schema
        return (
            <Box className="ml-6 -mt-2 flex flex-wrap">
                {
                    schema.properties &&
                    Object.keys(schema.properties).map((subproperty, subindex) => {
                        return (
                            <VEField {...props} key={subindex} schema={schema} parent={property} property={subproperty} />
                        );
                    })
                }
            </Box>
        );
    }

    function getResolutionSize(resolution) {
        let width, height;

        switch (resolution) {
            case "sd":
                width = 640;
                height = 480;
                break;
            case "hd":
                width = 1280;
                height = 720;
                break;
            case "full-hd":
                width = 1920;
                height = 1080;
                break;
            case "squared":
                width = 1080;
                height = 1080;
                break;
            case "instagram-story":
                width = 1080;
                height = 1920;
                break;
            case "instagram-feed":
                width = 1080;
                height = 1350;
                break;
            case "twitter-landscape":
                width = 1920;
                height = 1200;
                break;
            case "twitter-portrait":
                width = 1200;
                height = 1920;
                break;
            default: break;
        }

        return { width, height };
    }
}